import { Breadcrumb, Input, Select, Space, Timeline } from 'antd'
import React from 'react'
import { useState } from 'react'
import { ActiveDotIcon, BackIcon, CloseIcon, DotHour, InactiveDotIcon } from '../../../../asset'
import { t } from "i18next";
import style from './deliveryTypePage.module.css'
import SuccessModal from '../../../../component/modal/SuccessModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constant/routeConstant';
import TextArea from 'antd/es/input/TextArea';
import { useDeliveryType } from './DeliveryTypePage.hooks';
import { useEffect } from 'react';
import { data } from 'autoprefixer';
import ModalConfirmLeave from '../../../../component/modal/ModalConfirmLeave';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import NotifFailedSaved from '../../../../component/modal/NotifFailedSaved';
import CustomToogle from '../../../../component/toogle/CustomToogle';
import ModalFailedDelete from '../../../../component/modal/ModalFailedDelete';


export default function DeliveryTypeEdit() {

    const { state } = useLocation()
    const {
        doGetDetailDeliveryType,
        successModalOpen,
        failedModalOpen,
        messageFailed,
        setSuccessModalOpen,
        detailDeliveryType,
        deliveryTypeDescriptionError,
        deliveryTypeError,
        onChange,
        doEditDeliveryType,
        checkEdit,
        isEdited,
        setShowConfirm,
        showConfirm,
        setEditedData,

        setFailedModalOpen,
        operationalDate,
        error,
        form,
        handleToogle,
        handleChangeTime,
        handleBlur,
        handleSupportMitraGro,
        isSupportMitraGro
    } = useDeliveryType()

    useEffect(() => {
        typeof state?.data?.delivery_type_id !== 'undefined' ?
            doGetDetailDeliveryType(state?.data?.delivery_type_id) :
            doGetDetailDeliveryType(state?.data?.id)
        setEditedData(state?.data)
    }, [])

    const navigate = useNavigate()

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>
            <NotifFailedSaved
                visible={failedModalOpen}
                message={"Data with this Delivery Type is already used by other, cant process this action"}
                action={() => { setFailedModalOpen(false) }}
            />
            <ModalConfirmLeave
                visible={showConfirm}
                action={() => setShowConfirm(false)}
                route={ROUTES.DELIVERY_TYPE.LIST}
            />

{/* <ModalFailedDelete
        show={failedModalOpen}
        onOk={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be deleted"
        description="Because Driver already made an order trip"
      /> */}

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => navigate(ROUTES.DELIVERY_TYPE.LIST)}
                closable={false}
                width={280}
                className={style.successModal}
                okText="Ok"
                title="Success"
                description="Your data has been updated"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Delivery Type`}
                menuLevel4={`${t("DELIVERY_TYPE_EDIT:TITLE")} ID ${detailDeliveryType?.delivery_type_id}`}
            />


            <div className="flex items-center gap-[22px]" onClick={() => checkEdit() }>
                <img src={BackIcon} className='cursor-pointer' alt="back-icon"/>
                <h1 className='font-sans-bold text-2xl cursor-pointer' id='title'>{`${t("DELIVERY_TYPE_EDIT:TITLE")} ${detailDeliveryType?.delivery_type}`}</h1>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                {/* <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("DELIVERY_TYPE_EDIT:DELIVERY_TYPE_INFORMATION")}</h3>

                <div className="flex flex-col gap-[16px]">
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_EDIT:DELIVERY_TYPE_ID_FIELD")}</label>
                        <Input style={{ width: 350 }} value={`${detailDeliveryType?.delivery_type_id}`} className='mt-[8px]' disabled />
                    </div>

                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_EDIT:DELIVERY_TYPE_FIELD")}</label>
                        <Input style={{ width: 350 }} className={`mt-[8px] ${deliveryTypeError ? `border-[1px] border-[#FF0000]` : ''}`} 
                            maxLength={256} 
                            onChange={(event) => onChange(event, 'delivery_type')} 
                            defaultValue={state?.data?.delivery_type}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${deliveryTypeError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>

                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_EDIT:DESCRIPTION_FIELD")}</label>
                        <TextArea
                            style={deliveryTypeDescriptionError ? { width: 350, resize: 'none', borderColor: `#FF0000`, borderWidth: 1 } : { width: 350, resize: 'none' }}
                            placeholder={t("DELIVERY_TYPE_ADD:DESCRIPTION_PLACEHOLDER")}
                            onChange={(event) => onChange(event, 'description')}
                            defaultValue={state?.data?.description}
                            maxLength={256}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${deliveryTypeDescriptionError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                </div> */}

<div className="flex">
            <div>
              <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                {t("Delivery Type Information")}
              </h3>
              <div className="flex">
                {/* line one */}
                <div className="gap-[40px] mb-[24px]">
                <div className="flex flex-col">
                  <label className="font-roboto font-medium text-[16px] text-md">
                    {t("Support MitraGro")}
                  </label>
                  <div className="flex w-[180px] h-[70px]">
                    <div className="mr-[8px]">
                    <CustomToogle
                          namespace={"tglsetallaccess"}
                          // checked={
                          //   d?.is_operational_active === "Y" ? true : false
                          // }
                          checked={isSupportMitraGro}
                          handleChange={(event) =>
                            handleSupportMitraGro(event)
                          }
                        />
                    </div>
                        <div className="font-roboto mt-2 text-[#424242] text-[16px] text-lg">{isSupportMitraGro ? "Support": "Not Support"}</div>
                        
                        {/* {d?.is_operational_active === "Y" ? "Open" : "Close"} */}
                      </div>
                  {/* <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${error?.delivery_code ? `visible` : `hidden`}`}>This field is required</p> */}
                </div>
                <div className="flex flex-col mb-[24px]">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("Delivery Type Code")}</label>
                        <Input style={{ width: 350 }} className={`mt-[8px] ${error?.delivery_code ? `border-[1px] border-[#FF0000]` : ''}`} 
                            maxLength={256} 
                            onChange={(event) => onChange(event, 'delivery_code')} 
                            value={form?.delivery_code}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${error?.delivery_code ? `visible` : `hidden`}`}>This field is required</p>
                    </div>

                    <div className="flex flex-col mb-[24px]">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_EDIT:DELIVERY_TYPE_FIELD")}</label>
                        <Input style={{ width: 350 }} className={`mt-[8px] ${error?.delivery_type ? `border-[1px] border-[#FF0000]` : ''}`} 
                            maxLength={256} 
                            onChange={(event) => onChange(event, 'delivery_type')} 
                            value={form?.delivery_type}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${error?.delivery_type ? `visible` : `hidden`}`}>This field is required</p>
                    </div>

                    <div className="flex flex-col mb-[24px]">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_EDIT:DESCRIPTION_FIELD")}</label>
                        <TextArea
                            style={error?.description ? { width: 350, resize: 'none', borderColor: `#FF0000`, borderWidth: 1 } : { width: 350, resize: 'none' }}
                            placeholder={t("DELIVERY_TYPE_ADD:DESCRIPTION_PLACEHOLDER")}
                            onChange={(event) => onChange(event, 'description')}
                            value={form?.description}
                            maxLength={256}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${error?.description ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                    {operationalDate.map((d, i) => (
            <>
              <div className="flex w-[680px] font-medium font-roboto text-base">
                <div className="w-[160px] h-[25px]">Start Trip</div>
                {
                  d?.is_operational_active === "Y" ?
                    <>
                      <div className="w-[160px]">Start Automatic at</div>
                      {/* <div className="w-[40%]"></div> */}
                      </>
                    : <></>
                }
              </div>
              <div className="flex w-[680px]">
                
              <div className="flex w-[160px] h-[70px]">
                    <div className="mr-[8px]">
                  <CustomToogle
                    namespace={"tglsetallaccess"}
                    checked={d?.is_operational_active === "Y"
                      ? true
                      : false
                    }
                    handleChange={() => handleToogle(d?.is_operational_active, i)}
                  /></div>
                  <div className="font-roboto mt-2 text-[#424242] text-[16px] text-lg">
                  
                  {d?.is_operational_active === "Y" ? "Open" : "Close"}
                </div>
                </div>
                {
                  d?.is_operational_active === "Y" ?
                    <>
                      <div className="w-[160px]">
                        <div className="flex w-[500px]">
                          <Input
                            className="mt-[8px] h-[47px] w-[55px] mr-2"
                            onChange={(value) =>
                              handleChangeTime(value, "operational_start_time", 0, i)
                            }
                            onBlur={() =>
                              handleBlur(
                                operationalDate[i]?.["operational_start_time"].split(":")[0],
                                "operational_start_time",
                                0,
                                i
                              )
                            }
                            // status={error?.shift_start_hour ? "error" : ""}
                            value={d?.operational_start_time.split(":")[0]}
                          />

                          <div className="text-red-100">
                            {/* {error?.shift_start_hour} */}
                          </div>
                          <img src={DotHour} alt="hour" />
                          <Input
                            className="mt-[8px] h-[47px] w-[55px] ml-2"
                            onChange={(value) =>
                              handleChangeTime(value, "operational_start_time", 1, i)
                            }onBlur={() =>
                              handleBlur(
                                operationalDate[i]?.["operational_start_time"].split(":")[1],
                                "operational_start_time",
                                1,
                                i
                              )
                            }
                            // status={error?.shift_start_min ? "error" : ""}
                            value={d?.operational_start_time.split(":")[1]}
                          />
                          {/* <div className="ml-5">
                      <img src={HourAM} alt="am" />
                    </div> */}
                          {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                        </div>
                      </div>
                          {/* <div className="ml-5">
                      <img src={HourPM} alt="pm" />
                    </div> */}
                          {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                        
                    </>
                    :
                    <>
                    </>
                }

              </div>
            </>
          ))}
                </div>

                {/* LINE TWO */}
                <div className="gap-[40px] mb-[24px] mt-[-50px]">
                <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                {t("Cost Information")}
              </h3><div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("Cost/Kg")}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="Rp"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => onChange(value, "price_weight")}
                        status={error?.price_weight ? "error" : ""}
                        value={form?.price_weight}
                        placeholder="5.000.000"
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.price_weight}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("Cost/m")}<sup>3</sup>
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="Rp"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => onChange(value, "price_volume")}
                        status={error?.price_volume ? "error" : ""}
                        value={form?.price_volume}
                        placeholder="5.000.000"
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.price_volume}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("Cost/Km")}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="Rp"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => onChange(value, "price_distance")}
                        status={error?.price_distance ? "error" : ""}
                        value={form?.price_distance}
                        placeholder="5.000.000"
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.price_distance}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("Cost/hours")}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="Rp"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => onChange(value, "price_time")}
                        status={error?.price_time ? "error" : ""}
                        value={form?.price_time}
                        placeholder="5.000.000"
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.price_time}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("Base Price")}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="Rp"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => onChange(value, "base_price")}
                        status={error?.base_price ? "error" : ""}
                        value={form?.base_price}
                        placeholder="5.000.000"
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.base_price}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => doEditDeliveryType(detailDeliveryType)} >
                    {t("DELIVERY_TYPE_EDIT:SAVE_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={() => checkEdit() }>
                    {t("DELIVERY_TYPE_EDIT:CANCEL_BUTTON")}
                </button>
            </div>

        </div>
    )
}
